"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chevronDown = void 0;
var chevronDown = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"
    }
  }]
};
exports.chevronDown = chevronDown;